export enum FILTER_TRANSACTION_TYPE {
	ALL = 'All Transactions',
	PAYMENT = 'Payment',
	REFUND = 'Refund',
}

export enum FILTER_REDEMPTION_TYPE {
	ALL = 'All Redemptions',
	DEALS = 'Deals',
	PRIVILEGES = 'Privileges',
}

export enum TRANSACTION_CATEGORY {
	REDEMPTION = 'Redemptions',
	TRANSACTION = 'Transactions',
}

export enum REDEMPTION_TYPE {
	PRIVILEGE = 'KP_PRIVILEGE',
	DEAL = 'KP_VOUCHER',
}

export enum TRANSACTION_TYPE {
	TRANSACTION = 'Transaction',
	REDEMPTION = 'Redemption',
}

export const ALL = 'ALL';

export const REFUNDABLE_PERIOD_BY_MILLISECONDS = 1000 * 60 * 60 * 24;

export const RECENT_TXN_LIMIT_MIN = 2;

export const TXN_ERROR_MESSAGE = {
	KFWE0011: {
		TITLE: 'Transaction has already been refunded',
		DESCRIPTION: 'Please refresh the page to see the updated transaction status.',
		BTN_TEXT: 'Refresh page',
	},
	GENERAL_ERROR: {
		TITLE: 'We are unable to complete your request right now',
		BTN_TEXT: 'Go back Home',
	},
};

export enum PAYMENT_METHOD {
	TOKEN = 'TOKEN',
	AE = 'AE',
	GO = 'GO'
}